export class TerminalContextConstants {

    // Status handling
    public static readonly isLoading = 'isLoading';
    public static readonly responseMessages = 'responseMessages';
    public static readonly transportMasterdataValidityState = 'transportMasterdataValidityState';
    public static readonly transportInstructionsValidityState = 'transportInstructionsValidityState';
    public static readonly transportInstructionsDetailsShownState = 'transportInstructionsDetailsShownState';
    public static readonly transportOptionsValidityState = 'transportMasterdataValidityState';
    
    public static readonly transportOptionsAutoSelect = 'transportOptionsAutoSelect';

    public static readonly truckMasterdataValidityState = 'truckMasterdataValidityState';

    public static readonly visitorMasterdataValidityState = 'visitorMasterdataValidityState';

    // Communication
    public static readonly driverCommunication = 'driverCommunication';
    public static readonly DRIVER_COMMUNICATION_OWN_SMARTPHONE = 'OWN';
    public static readonly DRIVER_COMMUNICATION_LOANER = 'LOANER';

    // Actions
    public static readonly language = 'language';
    public static readonly registerTransport = 'registerTransport';
    public static readonly registerTruck = 'registerTruck';
    public static readonly registerVisitor = 'registerVisitor';

    // fields
    public static readonly logContainer = 'logContainer';
    public static readonly uuid = 'uuid';
    public static readonly registerTransportWithCode = 'registerTransportWithCode';
    public static readonly registerTransportWithQRCode = 'registerTransportWithQRCode';
    public static readonly registerTransportManually = 'registerTransportManually';
    public static readonly registrationCode = 'registrationCode';
    public static readonly numberPlate = 'numberPlate';
    public static readonly trailerNumberPlate = 'trailerNumberPlate';
    public static readonly orderReference = 'orderReference';
    public static readonly driver = 'driver';
    public static readonly coDriver = 'coDriver';
    public static readonly supplier = 'supplier';
    public static readonly carrier = 'carrier';
    public static readonly gcCaseId = 'gcCaseId';
    public static readonly gcCaseUrl = 'gcCaseUrl';
    public static readonly registrationId = 'registrationId';
    public static readonly selectedOptions = 'selectedOptions';
    public static readonly smartphoneConnected = 'smartphoneConnected';
    public static readonly captures = 'captures';
    public static readonly instructions = 'instructions';
    public static readonly registrationStarted = 'registrationStarted';
    public static readonly registrationFinished = 'registrationFinished';
    public static readonly gatekeeperMandatory = 'gatekeeperMandatory';
    public static readonly phoneNumber = 'phoneNumber';
    public static readonly vehicleType = 'vehicleType';

    public static readonly company = 'company';
    public static readonly lastname = 'lastname';
    public static readonly firstname = 'firstname';
    public static readonly reasonForVisit = 'reasonForVisit';
    public static readonly validity = 'validity';
    public static readonly visitedPerson = 'visitedPerson';
}
